import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';
import { SkillAcknowledgementRequestDto } from '../models/skill-acknowledgement-request-dto';

@Injectable({
  providedIn: 'root'
})
export class MySkillAcknowledgementsService {

  constructor(private httpClient: HttpClient) { }
  getMySkillAcknowledgements(includeAll: boolean): Observable<any> {
    return this.httpClient.get(ApiConstants.SkillAcknowledgement_Acknowledge_Api +"/"+ includeAll);
  }
  acknowledgeSkills(acknowledgeSkills: SkillAcknowledgementRequestDto): Observable<any> {
    return this.httpClient.put(ApiConstants.SkillAcknowledgement_Acknowledge_Api, acknowledgeSkills);
  }
}
